import { Action } from '@ngrx/store';

export const STORAGE = '@ngrx/store/storage';

export class Storage implements Action {
  public readonly type = STORAGE;
  constructor(public readonly payload: string) {}
}
